module.exports = {"320722001":"牛山街道","320722002":"石榴街道","320722101":"白塔埠镇","320722103":"黄川镇","320722104":"石梁河镇","320722105":"青湖镇","320722107":"温泉镇","320722108":"双店镇","320722109":"桃林镇","320722110":"洪庄镇","320722111":"安峰镇","320722112":"房山镇","320722113":"平明镇","320722200":"驼峰乡","320722203":"李埝乡","320722204":"山左口乡","320722205":"石湖乡","320722206":"曲阳乡","320722207":"张湾乡","320722401":"江苏东海经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320722.json
// module id = 820
// module chunks = 0